/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelVIcon20Light = forwardRef('ArrowParallelVIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M1.752 7.717a.5.5 0 1 1-.708-.707l3.273-3.273a1.672 1.672 0 0 1 2.365 0L9.955 7.01a.5.5 0 1 1-.707.707L6 4.469v11.78a.5.5 0 1 1-1 0V4.47L1.752 7.717Z" }),
        React.createElement("path", { d: "M15 15.531V3.75a.5.5 0 0 0-1 0V15.53l-3.248-3.248a.5.5 0 1 0-.707.707l3.273 3.273a1.672 1.672 0 0 0 2.364 0l3.273-3.273a.5.5 0 1 0-.707-.707L15 15.531Z" })));
});
